import rc from './router.config'
import vf from './vuefiles'
//路由列表
let routers = []
//路由节点key
const router_node_keys = ['redirect','file','path','children','sub','name','hidden']

let toString = Object.prototype.toString

const isString = function(obj){
    return toString.call(obj) === '[object String]'
}

const isUndefined = function(obj) {
    return obj === void 0
}
/**
 * 获得Vue Component
 * @param  {[type]} file [description]
 * @param  {[type]} sync [description]
 * @return {[type]}      [description]
 */
function vc(file,sync = false){
    let key = file.replace(/\//g,'_').replace('-','$')
    if(sync){
        key = 'page'+file
        return vf[key]
    }
    return vf[key]
}

/**
 * 创作路由节点
 * @param  {[type]} config [description]
 * @return {[type]}        [description]
 */
function create_router_node(configs,parent = []){
    let routers = []
    
    function get_file(key,cfg){
        if(cfg.file){
            return cfg.file
        }
        let dirs = []
        if(parent.length > 1){
            let i = 0;
            parent.forEach(p=>{
                if(i > 0){
                    dirs.push(p.path)
                }
                i++
            })
        }
        dirs.push(key)
        let file = dirs.join('/')
        if(file.substr(0,1) == '/'){
            file = file.substr(1)
        }
        return file
    }

    for(let key in configs){
        let local_parent = []
        if(parent.length > 0){
            parent.forEach(p=>{
                local_parent.push(p)
            })
        }
        let cfg = configs[key]
        if(isString(cfg)){
            cfg   = {
                title:cfg
            }
        }
        let node = {}
        let file = get_file(key,cfg)
        let sync = cfg.sync ? cfg.sync : false
        node.name = key
        node.path = cfg.path ? cfg.path : parent.length == 0 ? '/' + key : key
        if(key != 'any'){
            node.component = vc(file,sync)
        }
        if(cfg['redirect']){
            node.redirect = cfg.redirect
        }
        node.meta = {}

        for(let k in cfg){
            let v = cfg[k]
            if(router_node_keys.indexOf(k) === -1){
                node.meta[k] = v
            }
        }

        if(cfg.hidden){
            node.hidden = cfg.hidden
        }

        if(cfg.sub){
            local_parent.push(node)
            node.children = create_router_node(cfg.sub,local_parent)
        }

        routers.push(node)
    }
        
    return routers
}

routers = create_router_node(rc)

export default routers;


// WEBPACK FOOTER //
// ./src/router1.js